import { useQuery } from "@tanstack/react-query";
import { getDashboardDataApi } from "../model/dashboardApi";
import { QUERY_KEYS } from "@/constants/queryKeys";

/**
 * Dashboard ViewModel
 * Manages dashboard data and business logic
 */
export const useDashboardViewModel = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: [QUERY_KEYS.DASHBOARD],
    queryFn: getDashboardDataApi,
  });

  return {
    data: data || null,
    isLoading,
    error: error as Error | null,
    isSuccess: !!data && !error,
    isError: !!error,
    refetch,
  };
};
